// source: design/src/pages/HomePage.tsx (ProductsSection)
export default {
  sectionTitle: '製品とサービス',
  sectionTitleEn: 'Products & Services',
  sectionDescription: 'IT、ロボット技術、そして設計・開発力を融合させ、システムインテグレーションから製品イノベーションに至るまで、企業にワンストップのソリューションを提供します。',
  services: [
    {
      id: 'services_ifs-solution',
      icon: 'services/icons/database.svg',
      partnerIcon: 'services/icons/ifs_partner.png',
      name: 'IFS ソリューション',
      service: 'IFS Solutions',
      description: '企業の財務、調達、生産、販売、人事などの主要な業務プロセスを統合し、データの統合管理とリアルタイムな意思決定支援を実現することで、業務効率を向上させます。',
      tags: ['ERP', 'EAM', 'FSM', 'AI'],
      actionText: '詳細を見る',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'ifs',
    },
    {
      id: 'services_system-integration',
      // source: design/src/pages/HomePage.tsx (icon: Database, export 2026-04-24)
      icon: 'services/icons/system-integration.svg',
      name: 'SI システムインテグレーション',
      service: 'System Integration',
      description: 'システムの企画・開発・統合から運用・保守サポートに至るまで、企業の業務とITシステムを連携させ、効率的かつ円滑な連携を実現するデジタルソリューションを構築します。',
      tags: ['MES', 'WMS', 'AI'],
      actionText: '詳細を見る',
      // source: design/src/pages/HomePage.tsx (icon: ArrowRight, export 2026-04-24)
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'si',
    },
    {
      id: 'services_robot-solution',
      // source: design/src/pages/HomePage.tsx (icon: MessageSquare, export 2026-04-24)
      icon: 'services/icons/robot.svg',
      name: 'ロボットソリューション',
      service: 'Robotics Solutions',
      description: 'スマートロボット技術で企業を支援し、作業の自動化、インテリジェントな巡回点検、効率的な運用・保守を実現することで、生産および業務の効率を向上させます。',
      tags: ['四足歩行ロボット', 'ロボット関節'],
      actionText: '詳細を見る',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'robot',
    },
    {
      id: 'services_uiux-design',
      // source: design/src/pages/HomePage.tsx (icon: Pencil, export 2026-04-24)
      icon: 'services/icons/pencil.svg',
      name: 'UI/UX デザイン＆開発',
      service: 'UI/UX Design & Development',
      description: 'ユーザーを中心としたデジタル体験の設計と開発。戦略から納品まで一貫して対応し、異なる利用シーンを統合し、ユーザーの文化と価値観に適合した優れたデザインと高品質な開発サービスを提供します。',
      tags: ['モバイル開発', 'アプリ開発', 'Web開発', 'ミニプログラム開発・運用'],
      actionText: '詳細を見る',
      actionIcon: 'services/icons/arrow-right.svg',
      routeName: 'uiux',
    },
  ],
};
